@import './cms-badge.scss';

.badge-name {
  font-weight: var(--cms-heading-base-font-weight);
}

.close-button:focus-visible,
.badge-link:focus-visible {
  outline: none;
  border-radius: var(--cms-border-radius-0125);
  box-shadow: 0 0 0 var(--cms-spacing-012) var(--cms-theme-focus-outlineInner),
    0 0 0 var(--cms-spacing-025) var(--cms-theme-focus-outlineOuter)
}